import './App.css';

import { useState } from "react";

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import ProductDownloadFunctions from './ProductDownloadFunctions';

function ProductDownload(props) {

    const [sShowEndUserLicenseAgreementDialog, setShowEndUserLicenseAgreementDialog] = useState(false);

    const [sProductDownloadInfos, setProductDownloadInfos] = useState([]);
    const [sProductDownloadInfosError, setProductDownloadInfosError] = useState('');

    const [sCurrentProductEdition, setCurrentProductEdition] = useState(-1);
    const [sCurrentDownloadType, setCurrentDownloadType] = useState(-1);
    const [sCurrentDownloadIndex, setCurrentDownloadIndex] = useState(-1);
    const [sCurrentFileName, setCurrentFileName] = useState('');

    function onDownloadButtonClick(e) {
        const items = e.target.value.split(',');
        setCurrentProductEdition(parseInt(items[0]));
        setCurrentDownloadType(parseInt(items[1]));
        setCurrentDownloadIndex(parseInt(items[2]));
        setCurrentFileName(items[3]);
        setShowEndUserLicenseAgreementDialog(true);
    }

    function agreeLicenseAgreementButtonClick() {
        setShowEndUserLicenseAgreementDialog(false);
        setProductDownloadInfosError('');
        ProductDownloadFunctions.download(sCurrentProductEdition, sCurrentDownloadType, sCurrentDownloadIndex, sCurrentFileName);
    }

    function notAgreeLicenseAgreementButtonClick() {
        setShowEndUserLicenseAgreementDialog(false);
        setProductDownloadInfosError('');
    }

    function getProductDownloadInfos() {
        return sProductDownloadInfos;
    }

    ProductDownloadFunctions.readEndUserLicenseAgreement();

    ProductDownloadFunctions.getProductDownloadInfos = getProductDownloadInfos;
    ProductDownloadFunctions.setProductDownloadInfos = setProductDownloadInfos;

    ProductDownloadFunctions.setProductDownloadInfosError = setProductDownloadInfosError;

    function renderEndUserLicenseAgreementLine(licenseAgreementLine) {
        return (<p>{licenseAgreementLine}</p>);
    }

    function renderEndUserLicenseAgreementTexts()
    {
        if (ProductDownloadFunctions.EndUserLicenseAgreementTexts !== null &&
            ProductDownloadFunctions.EndUserLicenseAgreementTexts.length > 0) {
            return (ProductDownloadFunctions.EndUserLicenseAgreementTexts.map(renderEndUserLicenseAgreementLine));
        }
    }

    function renderEndUserLicenseAgreementDialog() {
        return (
            <Dialog open={sShowEndUserLicenseAgreementDialog} fullWidth maxWidth="sm">
                <DialogTitle>End User License Agreement</DialogTitle>
                <DialogContent dividers={true} >
                <Card>
                    <CardContent  >
                        <table width={"100%"} cellpadding={"10"}>
                            <tr>
                                <td>
                                    <p>GDS DESIGN & DEVELOPMENT LTD.</p>
                                    <p>Copyright (C) 2012-{(new Date()).getFullYear()} GDS Design & Development Ltd.</p>
                                    {renderEndUserLicenseAgreementTexts()}
                                    <p>Copyright (C) 2012-{(new Date()).getFullYear()} GDS Design & Development Ltd.</p>
                                    <p>All trademarks and registered trademarks are property of their respective owners</p>
                                </td>
                            </tr>
                        </table>
                    </CardContent>
                    </Card>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={agreeLicenseAgreementButtonClick} >I Agree</Button>
                    <Button variant="contained" onClick={notAgreeLicenseAgreementButtonClick} >I Don't Agree</Button>
                </DialogActions>
            </Dialog>
        );
    }

    function renderProductPage() {
        if (sProductDownloadInfos.length <= 0) {
            ProductDownloadFunctions.getProductDownloadInfoCollection(props.productEditions);
        }

        return (
            <Card>
                <CardContent >
                    <table width={"100%"} cellpadding={"6"}>
                        {
                            sProductDownloadInfos.map((productDownloadInfo) => {
                                return (
                                    <tr>
                                        <table width={"100%"} cellpadding={"6"}>
                                            <tr>
                                                <td align={"left"} colSpan={"4"}>
                                                    <p style={{ color: "blue", fontSize: "20px", fontWeight: "bold" }}>
                                                        {ProductDownloadFunctions.getProductName(productDownloadInfo.productEdition)}
                                                    </p>
                                                </td>
                                            </tr>
                                            {
                                                productDownloadInfo.assemblies.map((assembly, index) => {
                                                    return (
                                                        <tr>
                                                            <td width={"20%"} />
                                                            <td width={"40%"} align={"left"}>
                                                                <p style={{ fontSize: "18px" }}>{assembly}</p>
                                                            </td>
                                                            <td width={"20%"}>
                                                                <Button variant="contained"
                                                                    value={
                                                                            productDownloadInfo.productEdition + ',' +
                                                                            ProductDownloadFunctions.DownloadTypeAssembly + ',' +
                                                                            index + ',' + 
                                                                            assembly
                                                                           }
                                                                    onClick={onDownloadButtonClick} >Download</Button>
                                                            </td>
                                                            <td width={"20%"} />
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {
                                                productDownloadInfo.guides.map((guide, index) => {
                                                    return (
                                                        <tr>
                                                            <td width={"20%"} />
                                                            <td width={"40%"} align={"left"}>
                                                                <p style={{ fontSize: "18px" }}>{guide}</p>
                                                            </td>
                                                            <td width={"20%"}>
                                                                <Button variant="contained"
                                                                    value={
                                                                        productDownloadInfo.productEdition + ',' +
                                                                        ProductDownloadFunctions.DownloadTypeGuide + ',' +
                                                                        index + ',' +
                                                                        guide
                                                                    }
                                                                    onClick={onDownloadButtonClick} >Download</Button>
                                                            </td>
                                                            <td width={"20%"} />
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {
                                                productDownloadInfo.samples.map((sample, index) => {
                                                    return (
                                                        <tr>
                                                            <td width={"20%"} />
                                                            <td width={"40%"} align={"left"}>
                                                                <p style={{ fontSize: "18px" }}>{sample}</p>
                                                            </td>
                                                            <td width={"20%"}>
                                                                <Button variant="contained"
                                                                    value={
                                                                        productDownloadInfo.productEdition + ',' +
                                                                        ProductDownloadFunctions.DownloadTypeSample + ',' +
                                                                        index + ',' +
                                                                        sample
                                                                    }
                                                                    onClick={onDownloadButtonClick} >Download</Button>
                                                            </td>
                                                            <td width={"20%"} />
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </tr>
                                )
                            })
                        }
                        <tr>
                            <td align={"left"} colSpan={"4"}>
                                <p style={{ color: "red", fontSize: "18px" }}>{sProductDownloadInfosError}</p>
                            </td>
                        </tr>
                    </table>
                </CardContent>
            </Card>
        );
    }

    return (
        <div>
            {renderEndUserLicenseAgreementDialog()}
            <br />
            {renderProductPage()}
            <br />
        </div>
    );
}

export default ProductDownload;
